import type { FC } from "react";

interface Props {
  createdAt?: string;
}

const DateHeader: FC<Props> = ({ createdAt }) => {
  const formatDateHeader = (iso?: string) => {
    if (!iso) return "";
    const d = new Date(iso);
    const dow = d.toLocaleDateString(undefined, { weekday: "short" });
    const mon = d.toLocaleDateString(undefined, { month: "short" });
    const day = d.getDate();
    return `${dow}, ${mon} ${day}`;
  };

  const label = formatDateHeader(createdAt);

  return (
    <div
      aria-level={3}
      className="my-3 flex w-full items-center justify-center"
      role="heading"
    >
      <span className="rounded-full bg-gray-100 px-3 py-1 text-[11px] font-medium text-ink-700">
        {label}
      </span>
    </div>
  );
};

export default DateHeader;
